// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"project_sectionTitle__cSTvs","title":"project_title__7muCH","cardHeader":"project_cardHeader__-US_T"};